// src/Admin/HeroManager.jsx
import React, { useState, useEffect } from "react";

export default function HeroManager() {
  const [heroes, setHeroes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    subtitle: "",
    button_text: "Shop Now",
    button_link: "/collections",
    image: null,
  });

  const API_URL = "/api/heroes/";

 // src/Admin/HeroManager.jsx

const fetchHeroes = async () => {
  try {
    const res = await fetch(API_URL);
    const data = await res.json();

    // DJANGO NOW SENDS FULL DATA – WE JUST USE IT
    const safeHeroes = data.map(hero => ({
      id: hero.id || Date.now(), // fallback if ID missing
      title: hero.title || "No Title",
      subtitle: hero.subtitle || "",
      button_text: hero.button_text || "Shop Now",
      button_link: hero.button_link || "/collections",
      image: hero.image || "https://via.placeholder.com/800x600.png?text=No+Image"
    }));

    setHeroes(safeHeroes);
    setLoading(false);
  } catch (err) {
    console.error("Fetch error:", err);
    setLoading(false);
  }
};

useEffect(() => {
  fetchHeroes();
}, []); // Runs once on mount

  // Handle form submit (Add new slide)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.image) {
      alert("Please select an image!");
      return;
    }

    setUploading(true);
    const form = new FormData();
    form.append("title", formData.title);
    form.append("subtitle", formData.subtitle);
    form.append("button_text", formData.button_text);
    form.append("button_link", formData.button_link);
    form.append("image", formData.image);

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        body: form,
      });

      if (res.ok) {
        alert("Slide added successfully!");
        fetchHeroes(); // Refresh list
        setFormData({
          title: "",
          subtitle: "",
          button_text: "Shop Now",
          button_link: "/collections",
          image: null,
        });
        e.target.reset(); // Clear file input
      } else {
        alert("Upload failed. Try again.");
      }
    } catch (err) {
      alert("Network error!");
    } finally {
      setUploading(false);
    }
  };

  // Delete hero
  const deleteHero = async (id) => {
  if (!id || id === "undefined") {
    alert("Invalid slide ID!");
    return;
  }

  if (!window.confirm("Delete this slide permanently?")) return;

  try {
    const res = await fetch(`${API_URL}${id}/`, {
      method: "DELETE",
    });

    if (res.ok || res.status === 204) {
      alert("Deleted successfully!");
      fetchHeroes();
    } else {
      alert("Delete failed!");
    }
  } catch (err) {
  }
};
  return (
    <div className="p-6 max-w-7xl mx-auto bg-gray-50 min-h-screen">
      <h2 className="text-4xl font-bold mb-8 text-gray-800 text-center">Hero Slider Manager</h2>

      {/* ADD NEW SLIDE */}
      <div className="bg-white rounded-3xl shadow-xl p-10 mb-12 border border-gray-200">
        <h3 className="text-2xl font-bold mb-8 text-gray-800">Add New Slide</h3>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <input
            type="text"
            placeholder="Title (e.g. Summer Collection 2025)"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            className="px-6 py-4 border-2 border-gray-300 rounded-xl text-lg focus:border-black transition"
            required
          />
          <input
            type="text"
            placeholder="Subtitle (e.g. Up to 70% Off)"
            value={formData.subtitle}
            onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
            className="px-6 py-4 border-2 border-gray-300 rounded-xl text-lg focus:border-black transition"
            required
          />
          <input
            type="text"
            placeholder="Button Text"
            value={formData.button_text}
            onChange={(e) => setFormData({ ...formData, button_text: e.target.value })}
            className="px-6 py-4 border-2 border-gray-300 rounded-xl text-lg focus:border-black transition"
          />
          <input
            type="text"
            placeholder="Button Link (e.g. /sale)"
            value={formData.button_link}
            onChange={(e) => setFormData({ ...formData, button_link: e.target.value })}
            className="px-6 py-4 border-2 border-gray-300 rounded-xl text-lg focus:border-black transition"
          />
          <div className="md:col-span-2">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
              className="block w-full text-lg text-gray-700 file:mr-4 file:py-4 file:px-6 file:rounded-xl file:border-0 file:bg-black file:text-white file:font-bold hover:file:bg-gray-800"
              required
            />
          </div>
          <button
            type="submit"
            disabled={uploading}
            className={`md:col-span-2 py-5 rounded-xl font-bold text-xl text-white transition ${
              uploading ? "bg-gray-500" : "bg-black hover:bg-gray-900"
            }`}
          >
            {uploading ? "Uploading..." : "ADD SLIDE"}
          </button>
        </form>
      </div>

      {/* CURRENT SLIDES */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {loading ? (
          <div className="col-span-3 text-center py-20">
            <p className="text-2xl text-gray-600">Loading slides...</p>
          </div>
        ) : heroes.length === 0 ? (
          <div className="col-span-3 text-center py-20 bg-white rounded-3xl shadow-lg">
            <p className="text-3xl text-gray-500">No slides yet. Add your first one!</p>
          </div>
        ) : (
          heroes.map((hero) => (
            <div
              key={hero.id}
              className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-200 hover:shadow-3xl transition transform hover:-translate-y-2"
            >
              <div className="relative group">
                <img
                  src={hero.image}
                  alt={hero.title}
                  className="w-full h-72 object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition"></div>
              </div>
              <div className="p-8">
                <h4 className="text-2xl font-bold text-gray-800 mb-2">{hero.title}</h4>
                <p className="text-gray-600 text-lg mb-4">{hero.subtitle}</p>
                <div className="text-sm text-gray-500 space-y-1">
                  <p>Button: <span className="font-medium">{hero.button_text}</span></p>
                  <p>Link: <span className="font-medium">{hero.button_link}</span></p>
                </div>
                <button
                  onClick={() => deleteHero(hero.id)}
                  className="mt-8 w-full bg-red-600 text-white py-4 rounded-xl font-bold hover:bg-red-700 transition shadow-lg"
                >
                  DELETE SLIDE
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}